import { combineReducers, configureStore, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import authenticationReducer, { AuthenticationState } from './slices/authenticationSlice'
import institutionReducer, { InstitutionState } from './slices/institutionSlice'
import playerReducer, { PlayerState } from './slices/playerSlice'
import moduleReducer, { ModuleState } from './slices/moduleSlice'
import { quizApi } from './services/quiz'
import quizReducer, { QuizState } from './slices/quizSlice'
import { errorHandling } from './middleware'

interface AppState {
  authentication: AuthenticationState
  institution: InstitutionState
  module: ModuleState
  player: PlayerState
  quizApi: any
  quiz: QuizState
}

const combinedReducer = combineReducers({
  authentication: authenticationReducer,
  institution: institutionReducer,
  player: playerReducer,
  module: moduleReducer,
  [quizApi.reducerPath]: quizApi.reducer,
  quiz: quizReducer
})

// The root reducer will allow us to have one action for RESET, which clears
// all of the data from the entire store (used on log out).
const rootReducer = (state: AppState | undefined, action: PayloadAction<any>): AppState => {
  if (action.type === 'RESET') {
    state = undefined
  }
  return combinedReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(quizApi.middleware).concat(errorHandling)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
